import { useState } from "react";
import DrawerButton from "components/form/DrawerButton";
import Error from "components/form/Error";
import LabelArea from "components/form/LabelArea";
import Title from "components/form/Title";
import useOnewayPickupBasicRateSubmit from "hooks/OnewayPickupSubmit";
import DynamicOneWayPickupInput from "components/form/DynamicOneWayPickupInput";
import OnewayPickupSelectCity from "components/form/OneWayselectCity";
import React from "react";
import Scrollbars from "react-custom-scrollbars-2";
import { Input } from "@windmill/react-ui";



const OnewayPickupBasicRateDrawer = ({ id }) => {
    const {
        setSelectedOptions,
        selectedOptions,
        handleVehicleCategoryChange,
        setDataInput,
        dataInput,
        handleChangeInput,
        register,
        handleSubmit,
        fromCity,
        toCity,
        onSubmit,
        handleFromCityChange,
        handleToCityChange,
        selectedVehicleCategory,
        trigger,
        errors,
        minKm,
        setMinKm
    } = useOnewayPickupBasicRateSubmit(id);

    return (
        <>
            <div className="w-full relative p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
                {id ? (
                    <Title title={"Edit Oneway Pickup Basic Rate"} description={""} />
                ) : (
                    <Title title={"Add OneWay Pickup Basic Rate"} description={""} />
                )}
            </div>
            <Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="px-6 pt-8 flex-grow scrollbar-hide w-full max-h-full pb-40">
                        <div className="gap-3 mb-6">
                            <div className="grid grid-cols-6 gap-3 mb-6" style={{ display: "flex", justifyContent: "space-between" }}>
                                <div style={{ width: "100%" }} >
                                    <LabelArea label={"From City"} />
                                    <OnewayPickupSelectCity
                                        register={register}
                                        name="from_city"
                                        label="From City"
                                        selectedCity={fromCity}
                                        handleCityChange={handleFromCityChange}
                                    />
                                </div>
                                <div style={{ width: "100%" }} >
                                    <LabelArea label={"To City"} />
                                    <OnewayPickupSelectCity
                                        register={register}
                                        name="to_city"
                                        label="To City"
                                        selectedCity={toCity}
                                        handleCityChange={handleToCityChange}
                                    />
                                </div>

                                <Error errorName={errors.name_of_aiport} />
                            </div>
                            <div className="hidden xl:block">
                                <LabelArea label={"Kilometer"} />
                            </div>
                            <Input className="border h-10 text-sm focus:outline-none block  bg-white-100 dark:bg-white border-transparent focus:bg-white mb-6"
                                style={{ width: "50%" }}
                                value={minKm}
                                onChange={(e) => setMinKm(e.target.value)}
                                placeholder="Kilometer"
                            />



                            <DynamicOneWayPickupInput
                                register={register}
                                trigger={trigger}
                                errors={errors}
                                dataInput={dataInput}
                                setDataInput={setDataInput}
                                handleChange={handleChangeInput}
                                selectedOptions={selectedOptions}
                                setSelectedOptions={setSelectedOptions}
                                handleVehicleCategoryChange={handleVehicleCategoryChange}
                                selectedVehicleCategory={selectedVehicleCategory}

                            />
                        </div>
                    </div>

                    <DrawerButton id={id} title={id ? "Update" : "Submit"} />
                </form>
            </Scrollbars>
        </>
    );
};

export default OnewayPickupBasicRateDrawer;
